import React from "react";
import PropTypes from "prop-types";

const PlusIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5 12h14"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5v14"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

PlusIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PlusIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default PlusIcon;
